import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import { NgIf, NgFor } from '@angular/common';

@Component({
  selector: 'app-instructions',
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.scss'],
  standalone: true,
  imports: [NgIf, NgFor]
})
export class InstructionsComponent implements OnChanges {
  cdnImagePath: string = environment.cdnImagePath;
  commonImagePath: string = environment.commonImagePath;
  isVideoAvailable: boolean = false;

  @Input() instructionsData: any[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['instructionsData']?.currentValue) {
      this.instructionsData.forEach((instruction) => {
        if (instruction.video_url?.length > 0) {
          this.isVideoAvailable = true
        } else {
          this.isVideoAvailable = false
        }
      })
    }
  }
}